import Button from "../../../Button";
import { getImgUrl } from "../../../../utills";
import useText from "../../../../hooks/useText";
import { WHATS_APP_WHITE_IMAGE } from "../../../../GlobalConstant/image";

import styles from '../HelpWidgetsFormModal/HelpWidgetsFormModal.module.scss';

const WhatsAppForm = ({ whatsAppConfig }) => {
  const { getText } = useText();
  const { redirectionUrl, translations } = whatsAppConfig

  const handleClick = () => {
    window.open(redirectionUrl, '_blank')
  }

  return <>
    <div className={styles.header}>
      {getText(translations?.WHATSAPP_FORM_DES)}
    </div>
    <Button text={getText(translations?.WHATSAPP_BTN_TITLE)} icnUrl={getImgUrl(WHATS_APP_WHITE_IMAGE)} callBack={handleClick} />
  </>
}

export default WhatsAppForm